import { fetchProfile } from "../../services/FetchProfile";
import LandingLayout from "components/common/landingLayout";
import Home from "components/home";
import { useAuth } from "hooks/authentication/useAuth";
import { usePermission } from "hooks/permission/usePermission";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Empty = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { setPermissions } = usePermission();
  const fetchUserProfile = async () => {
    const { route } = await fetchProfile(auth, setPermissions);
    if (route) {
      navigate(route);
    } else {
      window.location = "/login";
    }
  };
  useEffect(() => {
    if (auth.user) {
      fetchUserProfile();
    } else window.location = "https://volksbank-digital.solutions";
  }, []);
};

export default Empty;
